module.exports = __webpack_public_path__ + "static/media/grains_item_list.e7242b88.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_item_list.csv
// module id = 734
// module chunks = 0